import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["color"];
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.number.constructor.js";
import React from 'react';
import styled from 'styled-components';
import { alpha, getColorBlock } from 'utils/ui/colors';
import VisuallyHidden from 'components/VisuallyHidden';

// TO DO: Make aria labels required
// https://github.com/5app/hub/issues/14124
function getMeterColor(_ref) {
  var value = _ref.value,
    _ref$low = _ref.low,
    low = _ref$low === void 0 ? 0 : _ref$low,
    _ref$high = _ref.high,
    high = _ref$high === void 0 ? 1 : _ref$high,
    _ref$min = _ref.min,
    min = _ref$min === void 0 ? 0 : _ref$min,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? 1 : _ref$max,
    theme = _ref.theme;
  if (value <= low || value === min) {
    return getColorBlock('negative', theme);
  } else if (value >= high || value === max) {
    return getColorBlock('positive', theme);
  } else {
    return getColorBlock('neutral', theme);
  }
}
function getMeterWidth(_ref2) {
  var value = _ref2.value,
    _ref2$min = _ref2.min,
    min = _ref2$min === void 0 ? 0 : _ref2$min,
    _ref2$max = _ref2.max,
    max = _ref2$max === void 0 ? 1 : _ref2$max,
    _ref2$visualMin = _ref2.visualMin,
    visualMin = _ref2$visualMin === void 0 ? 0 : _ref2$visualMin;
  var difference = max - min;
  var clampedValue = Math.max(value, visualMin);
  var fraction = (clampedValue - min) / difference;
  return "".concat(fraction * 100, "%");
}
var Wrapper = styled.div.withConfig({
  displayName: "Meter__Wrapper",
  componentId: "sc-1tfhqj9-0"
})(["width:100%;height:0.3rem;background-color:", ";"], function (p) {
  return alpha(p.theme.shade, 0.1);
});
var MockMeter = styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(propName) {
    return !['visualMin', 'min', 'max', 'low', 'high', 'value', 'meterColor'].includes(propName);
  }
}).withConfig({
  displayName: "Meter__MockMeter",
  componentId: "sc-1tfhqj9-1"
})(["width:", ";height:100%;background:", ";transition:width 300ms ease-out;"], getMeterWidth, function (p) {
  return p.meterColor ? getColorBlock(p.meterColor, p.theme) : getMeterColor(p);
});
function Meter(props) {
  var color = props.color,
    propsWithoutColor = _objectWithoutProperties(props, _excluded);
  var _props$min = props.min,
    min = _props$min === void 0 ? 0 : _props$min,
    _props$max = props.max,
    max = _props$max === void 0 ? 1 : _props$max,
    _props$visualMin = props.visualMin,
    visualMin = _props$visualMin === void 0 ? 0 : _props$visualMin,
    _props$low = props.low,
    low = _props$low === void 0 ? 0 : _props$low,
    _props$high = props.high,
    high = _props$high === void 0 ? 1 : _props$high,
    value = props.value;
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(MockMeter, {
    value: Number(value),
    visualMin: Number(visualMin),
    min: Number(min),
    max: Number(max),
    low: Number(low),
    high: Number(high),
    meterColor: color
  }), /*#__PURE__*/React.createElement(VisuallyHidden, _extends({
    as: "meter"
  }, propsWithoutColor)));
}
export default Meter;